import React from "react";
import { Navigate } from "react-router-dom";
import { hasAnyModule } from "./moduleaccessLogic";

export default function ModuleAccess({ anyOf, children }) {
  const stored = localStorage.getItem("userModules");
  return hasAnyModule(stored, anyOf) ? children : <Navigate to="/app/home" replace />;
}
